import script from "./returnTreasureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./returnTreasureView.vue?vue&type=script&setup=true&lang=ts"

import "./returnTreasureView.vue?vue&type=style&index=0&id=3933952e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3933952e"]])

export default __exports__